import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';

import Refund from '../../../components/purchase-dashboard/autopilot/refund';
import {
  getOrganizerMembership,
  getCurrentPurchase
} from '../../../selectors/purchase-selector';
import money, { Money } from '../../../lib/money';
import { AUTOPILOT_NAMESPACE } from '../../../actions';

class RefundContainer extends Component {
  get refundAmount() {
    const { organizerMembership: { shareAmount, contributions } } = this.props;
    if (!shareAmount || !contributions) return Money.zero(this.props.currencyCode);
    const contributionAmounts = contributions.map(c => money(c.shareAmount));
    const totalAmount = Money.sum(contributionAmounts);
    const refund = Money.subtract(totalAmount, money(shareAmount));
    const zeroRefund = Money.zero(refund.currencyCode);

    if (refund.isGreaterThan(zeroRefund)) return refund;
    return zeroRefund;
  }

  render() {
    const refund = money(this.refundAmount);
    if (refund.isZero()) return null;

    return (
      <Refund refund={refund} />
    );
  }
}

const mapStateToProps = (state) => {
  const { projections } = state;
  const orgMembership = getOrganizerMembership(state);
  const purchase = getCurrentPurchase(state);

  return {
    currencyCode: purchase.currencyCode,
    organizerMembership: get(projections, `${AUTOPILOT_NAMESPACE}.memberships.${orgMembership.id}`, {}),
  };
};

export default connect(mapStateToProps)(RefundContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/autopilot/refund.container.js